import React from 'react'
import Path from 'routes/path'
import { ownerName } from 'frontend_core/dist/helpers/format'
import HostSummary from './HostSummary'

export default ({ owner, service }) => (
  <div className="page__even page__padding">
    <div className="container">
      <div className="row">
        <HostSummary
          name={ownerName(owner)}
          profile={owner.profile}
          ownerPath={Path.owner(owner.username)}
          ownerProfileImage={owner.profileImage}
          isTopHost={owner.rank === 1}
          createdAt={owner.createdAt}
          confirmRate={{
            evaluation: owner.confirmRateEvaluation,
            text: owner.confirmRateText,
          }}
          replyRate={{
            evaluation: owner.replyRateEvaluation,
            text: owner.replyRateText,
          }}
          replyTimeAvg={{
            evaluation: owner.replyTimeAvgEvaluation,
            text: owner.replyTimeAvgText,
          }}
          isVerifiedFacebook={owner.isVerifiedFacebook}
          isVerifiedEmail={owner.isVerifiedEmail}
          isVerifiedTel={owner.isVerifiedTel}
          service={service}
        />
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/shared/HostSummary/index.jsx